class BinManifestController {
  /*@ngInject*/
  constructor() {}
  $onInit() {}
}

export default BinManifestController; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bin_manifest/bin_manifest.controller.js